export default {
    watch: {
        prepaySelected(value) {
            this.prepay = value === true ? 1 : 0;
        },
    },

    computed: {
        min() {
            return Math.min.apply(Math, this.extra.choices);
        },
        max() {
            return Math.max.apply(Math, this.extra.choices);
        },
        selectedExtras() {
            return this.$store.getters.getSelectedExtras;
        },
        selectedCurrency() {
            return this.$store.getters.selectedCurrency;
        },
        pricePerDay() {
            return this.prepay ? this.extra.prepay_price_per_day : this.extra.price_per_day;
        },
        originalPricePerDay() {
            let key = this.prepay ? 'original_prepay_price_per_day' : 'original_price_per_day';
            return typeof this.extra[key] !== 'undefined' ? this.extra[key] : null;
        },
        isSelected() {
            const selected = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id == this.extra.id;
            });

            return selected.length > 0;
        },
        choice() {
            const selectedExtraObjects = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id == this.extra.id;
            });

            return selectedExtraObjects.length ? parseInt(selectedExtraObjects[0].choice) : 0;
        },
        bothPaymentOptionsAvailable() {
            return this.extra.prepay_available && this.extra.pay_on_arrival_available;
        },
        availablePaymentOptionLabel() {
            if (this.extra.pay_on_arrival_available) {
                return 'booking-process.shared.pay_on_arrival_label';
            }

            return 'booking-process.shared.pay_online_label';
        },
        prepaySelected() {
            const selectedExtraObjects = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id == this.extra.id;
            });

            return selectedExtraObjects.length ? selectedExtraObjects[0].prepay : this.defaultPrepayValue;
        },
        defaultPrepayValue() {
            return this.extra.prepay_available;
        },
        numberStepperButtonLabel() {
            return this.isSelected
                ? 'booking-process.options_selection.remove_option_label'
                : 'booking-process.options_selection.add_option_label';
        },
        isFree() {
            const isFree = this.selectedExtras.filter(selectedExtra => {
                return selectedExtra.extra.data.id == this.extra.id && selectedExtra.free;
            });

            return isFree.length > 0;
        },
    },

    methods: {
        toggleExtra() {
            if (this.isSelected) {
                return this.$store.dispatch('deleteExtra', this.extra);
            } else {
                return this.$store.dispatch('createExtra', { extra: this.extra, prepay: this.prepaySelected });
            }
        },
        updateExtraChoice(choice) {
            if (choice != this.choice) {
                this.$store.dispatch('updateExtra', { extra: this.extra, choice: choice, prepay: this.prepaySelected });
            }
        },
        updateExtraPrepayStatus(prepay) {
            if (this.isSelected) {
                this.$store.dispatch('updateExtra', { extra: this.extra, prepay: prepay });
            }
        },
        fixedPriceForBookingTerm(extra) {
            return extra.price_per_day === extra.total_price;
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/mixins/OptionItem.js